/**
 * Hook + helpers para trackear entidades recientemente visitadas (localStorage).
 *
 * Se almacenan los últimos 8 únicos por (type, id) en `chirino_recents`.
 * Estructura: { type, id, label, sublabel, route, icon, visitedAt }
 */

const STORAGE_KEY = 'chirino_recents';
const MAX_RECENTS = 8;

const safeParse = (raw) => {
  try {
    return JSON.parse(raw) || [];
  } catch {
    return [];
  }
};

export const getRecents = () => {
  if (typeof window === 'undefined') return [];
  return safeParse(window.localStorage.getItem(STORAGE_KEY));
};

export const trackRecent = (entity) => {
  if (!entity || !entity.type || !entity.label) return;
  const id = entity.id || entity.label;
  const now = Date.now();
  const current = getRecents();
  // Quitar duplicados (mismo type + id)
  const filtered = current.filter((r) => !(r.type === entity.type && (r.id || r.label) === id));
  filtered.unshift({
    type: entity.type,
    id,
    label: entity.label,
    sublabel: entity.sublabel || '',
    route: entity.route || '',
    icon: entity.icon || 'FileText',
    visitedAt: now,
  });
  const trimmed = filtered.slice(0, MAX_RECENTS);
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // quota exceeded, ignore
  }
};

export const clearRecents = () => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
